import React, { FC, useRef, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { Popup } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Popup';
import { useShouldHideChannelProgram } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Layout/hooks/use-should-hide-channel-program';

import { ChannelProgramModalWithAnalytics } from '../../../../channel-program/ui/channel-program-modal/analytics';
import { BaseControlProps } from '../../../types/controls';
import { usePlayerPopupButton } from '../../../hooks/skin/use-player-popup-button';

import styles from './styles.module.css';

interface Props extends BaseControlProps {
    psid: string;
    className?: string;
}

export const ChannelProgramPopupButton: FC<Props> = ({ contentId, psid, className, onClick }) => {
    const { vsid } = usePlayerInstance() || {};
    const controlRef = useRef<HTMLDivElement>(null);
    const [isControlHovered, setIsControlHovered] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const { handleClick } = usePlayerPopupButton({
        isOpen,
        setIsOpen,
        onClick,
    });
    const { isNeedToHidePrograms } = useShouldHideChannelProgram(contentId);

    if (isNeedToHidePrograms) {
        return null;
    }

    return (
        <div
            onMouseEnter={() => setIsControlHovered(true)}
            onMouseLeave={() => setIsControlHovered(false)}
            ref={controlRef}
            className={classnames(styles.root, className)}
        >
            <button
                onClick={handleClick}
                className={styles.channelProgramButton}
                aria-expanded={isOpen}
            >
                <FormattedMessage
                    id="features.player.1a2afb42180bb93cf3196cc4d6e5f1f6"
                    defaultMessage="TV listings"
                    description="Текст телепрограмма в скине в фиче плеера"
                />
            </button>
            <Popup
                targetHovered={isControlHovered}
                lockTargetHover={setIsOpen}
                visible={isOpen}
                targetRef={controlRef}
                placement="top"
                enableSeamlessResize
            >
                <ChannelProgramModalWithAnalytics
                    contentId={contentId}
                    psid={psid}
                    vsid={vsid}
                    isOpened={isOpen}
                />
            </Popup>
        </div>
    );
};
